export default [
    {
        path: '/files',
        name: 'files',
        component: () => import('../views/files/FilesView.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/files/search',
        name: 'files-search',
        component: () => import('../views/files/FilesSearchView.vue'),
        meta: {
            requiresAuth: true,
        },
    },
]
